// Copyright (c) 2019 Comsearch, Inc., All rights reserved

export default {
  data: [],
  highlightedPathIds: [],
  setPathDetailsData: [],
}
